import React from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import { useAttachmentsInfo } from 'signer-app/utils/use-attachments-info';
import styles from './signer-toolbar.module.css';
import { Text } from '@dropbox/dig-components/typography';
import { Box } from '@dropbox/dig-foundations';
import { useBundleProps } from 'signer-app/bundle-props';
import classnames from 'classnames';

export const FieldCountIndicator = ({
  requiredFieldsLeft,
}: {
  requiredFieldsLeft: number;
}) => {
  const intl = useIntl();
  const { requiredAttachmentsLeft } = useAttachmentsInfo();
  const { hasCustomStyles } = useBundleProps();

  return (
    <Box
      className={classnames(styles.fieldCountIndicator, {
        [styles.fieldCountIndicatorWhiteLabeled]: hasCustomStyles,
      })}
    >
      <Text size="small" color={hasCustomStyles ? 'subtle' : 'standard'}>
        {requiredAttachmentsLeft
          ? intl.formatMessage(messages.requiredFieldsAndAttachmentsLeft, {
              requiredFieldsLeft,
              requiredAttachmentsLeft,
            })
          : intl.formatMessage(messages.requiredFieldsLeft, {
              requiredFields: requiredFieldsLeft,
            })}
      </Text>
    </Box>
  );
};
